export default __webpack_public_path__ + "static/media/iste1.451d7a23.png";